import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '../context/AuthContext';
import { deletePost } from '../services/postService';

export const useDeletePost = () => {
  const { apiCall } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (postId) => deletePost(apiCall, postId),
    onMutate: async (postId) => {
      const userPostsQueries = queryClient.getQueriesData({ queryKey: ['userPosts'] });
      
      await queryClient.cancelQueries({ queryKey: ['userPosts'] });
      
      const previousDataMap = new Map();
      
      userPostsQueries.forEach(([queryKey, oldData]) => {
        if (oldData) {
          previousDataMap.set(queryKey, oldData);
          
          queryClient.setQueryData(queryKey, {
            ...oldData,
            pages: oldData.pages.map(page => ({
              ...page,
              posts: page.posts?.filter(post => post._id !== postId) || []
            }))
          });
        }
      });

      return { previousDataMap };
    },
    onError: (error, postId, context) => {
      if (context?.previousDataMap) {
        context.previousDataMap.forEach((oldData, queryKey) => {
          queryClient.setQueryData(queryKey, oldData);
        });
      }
    
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['userPosts'] });
    }
  });
};